import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
  theme?: 'light' | 'dark';
}
export function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center',
  className = '',
  theme = 'light'
}: SectionHeaderProps) {
  const alignmentClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  const titleColor = theme === 'light' ? 'text-verde-oscuro' : 'text-blanco';
  const descColor = theme === 'light' ? 'text-gris' : 'text-white/65';
  const eyebrowBg = theme === 'light' ? 'bg-dorado-suave text-verde-oscuro' : 'bg-dorado/15 text-dorado-claro';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`${alignmentClass} ${className}`} data-id="element-295">
      <div className={`inline-block text-[14px] md:text-[12px] font-semibold tracking-[2px] uppercase px-4 py-2 rounded-[2px] mb-5 ${eyebrowBg}`} data-id="element-296">
        {eyebrow}
      </div>
      <h2 className={`font-display text-[clamp(32px,5vw,52px)] font-black leading-[1.2] mb-4 ${titleColor}`} data-id="element-297">
        {title}
      </h2>
      <div className="w-[60px] h-[2px] bg-dorado mx-auto mb-6" data-id="element-298" />
      {description && <p className={`text-[17px] md:text-[18px] max-w-[600px] mx-auto leading-[1.8] ${descColor}`} data-id="element-299">
          {description}
        </p>}
    </motion.div>;
}